import {z} from 'zod';

import {UuidResponseBodySchema} from '@dms/api/shared';

export const UploadLicensePlateRemovalFileRequestBodySchema = z.object({
  filename: z.string(),
  fileContent: z.string(), // base64 string
});

export const UploadLicensePlateRemovalFileApiArgSchema = z.object({
  uploadLicensePlateRemovalFileRequestBody: UploadLicensePlateRemovalFileRequestBodySchema,
});

export type UploadLicensePlateRemovalFileApiArg = z.infer<
  typeof UploadLicensePlateRemovalFileApiArgSchema
>;

export const UploadLicensePlateRemovalFileApiResponseSchema = UuidResponseBodySchema;
export type UploadLicensePlateRemovalFileApiResponse = z.infer<typeof UuidResponseBodySchema>;

// POST OFFER
export const CreateOfferSettingRequestBodySchema = z.object({
  branchId: z.string().nullable(),
  validityEnabled: z.boolean(),
  validityDays: z.number().int().nullable(),
});
export type CreateOfferSettingRequestBody = z.infer<typeof CreateOfferSettingRequestBodySchema>;
export const CreateOfferSettingApiArgSchema = z.object({
  createOfferSettingRequestBody: CreateOfferSettingRequestBodySchema,
});
export type CreateOfferSettingApiArg = z.infer<typeof CreateOfferSettingApiArgSchema>;
export const CreateOfferSettingApiResponseSchema = UuidResponseBodySchema;
export type CreateOfferSettingApiResponse = z.infer<typeof UuidResponseBodySchema>;

// UPDATE OFFER
export const UpdateOfferSettingRequestBodySchema = z.object({
  branchId: z.string().nullable(),
  validityEnabled: z.boolean(),
  validityDays: z.number().int().nullable(),
});
export type UpdateOfferSettingRequestBody = z.infer<typeof UpdateOfferSettingRequestBodySchema>;
export const UpdateOfferSettingApiArgSchema = z.object({
  settingId: z.string().uuid(),
  updateOfferSettingRequestBody: UpdateOfferSettingRequestBodySchema,
});
export type UpdateOfferSettingApiArg = z.infer<typeof UpdateOfferSettingApiArgSchema>;
export type UpdateOfferSettingApiResponse = void;

// GET OFFER
export const GetOfferSettingApiArgSchema = z.object({
  settingId: z.string().uuid(),
});
export type GetOfferSettingApiArg = z.infer<typeof GetOfferSettingApiArgSchema>;
export const OfferSettingResponseBodySchema = z.object({
  id: z.string().uuid(),
  branchId: z.string().nullable(),
  validityEnabled: z.boolean(),
  validityDays: z.number().int().nullable(),
});
export type OfferSettingResponseBody = z.infer<typeof OfferSettingResponseBodySchema>;
export type GetOfferSettingApiResponse = OfferSettingResponseBody;

// DELETE OFFER
export const DeleteOfferSettingApiArgSchema = z.object({
  settingId: z.string().uuid(),
});
export type DeleteOfferSettingApiArg = z.infer<typeof DeleteOfferSettingApiArgSchema>;
export type DeleteOfferSettingApiResponse = void;
